import { CampaignSettings } from './CampaignSettings';
import CRMIntegration from './CRMIntegration';
import { OutboundConfigurations } from './OutboundConfigurations';
import { ScheduleSettings } from './ScheduleSettings';

export default function SettingsContent() {
  return (
    <div className="p-4 space-y-6">
      <ScheduleSettings />
      <CRMIntegration />
      <OutboundConfigurations />
      <CampaignSettings />
    </div>
  );
}
